// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"e53532b4","238":"cf3bc18a","602":"c33374a9","859":"6ba3fa78"}[chunkId] + ".chunk.js";
};